<template>
    <div id="stockRemoval">
        <Modal width="750px" v-model="stockRemVal.show" title="自提出库确认" @on-ok="submint" @on-cancel="cancels" :loading="loading">
            <Form ref="formValidate" label-position="right" inline :model="formDate" :rules="ruleValidate" :label-width="110">
                <FormItem label="交付计划编号">
                    <Input disabled v-model="stockRemVal.id" style="width:180px" />
                </FormItem>
                <FormItem label="自提数量" prop="confirmAmount">
                    <InputNumber :min="1" v-model="formDate.confirmAmount" style="width:180px" />
                </FormItem>
                <br />
                <FormItem label="交付时间" prop="confirmTime">
                    <DatePicker type="date" :editable="false" :options="optionsDate" placeholder="请选择日期" v-model="formDate.confirmTime" @on-change="onChangeTime" style="width: 200px"></DatePicker>
                </FormItem>
                <br />
                <FormItem label="备注">
                    <Input v-model="formDate.selfPickAckComment" type="textarea" style="width:490px" />
                </FormItem>
                <br />
                <FormItem label="上传附件">
                    <upload ref="upFiles" :height="70" :width="489" :format="[]" title="上传附件" @success="uploadSuccess" @delete="onDelete"></upload>
                </FormItem>
                <!-- <FormItem label="是否校验库存" prop="isStronglyValidateInventory">
                    <Select v-model="formDate.isStronglyValidateInventory" placeholder="请选择" style="width:180px">
                        <Option value="true">是</Option>
                        <Option value="no">否</Option>
                    </Select>
                </FormItem>-->
            </Form>
        </Modal>
    </div>
</template>

<script>
import upload from '@/components/upload/upload';

export default {
    components: { upload },
    props: {
        stockRemVal: { type: Object, default: {} }
    },
    data() {
        return {
            loading: true,
            formDate: {
                deliveryPlanId: '',
                confirmTime: '',
                confirmAmount: null,
                isStronglyValidateInventory: true,
                attachmentFileIds: [],
                selfPickAckComment:"",//备注
            },
            ruleValidate: {
                confirmAmount: [{ required: true, message: '自提数量不能为空！' }],
                confirmTime: [{ required: true, message: '请选择时间！', trigger: 'change' }],
            },
            optionsDate: {
                disabledDate(date) {
                    return date && date.valueOf() > Date.now()
                }
            },

        }
    },
    methods: {
        // 时间
        onChangeTime(val) {
            this.formDate.confirmTime = val
        },
        // 上传附件回调
        uploadSuccess(params) {
            this.formDate.attachmentFileIds.push(params.body)
        },
        // 上传附件删除回调
        onDelete({id}) {
            this.formDate.attachmentFileId = this.formDate.attachmentFileId.filter(item => item != id);
        },
        submint() {
            this.$refs['formValidate'].validate((valid) => {
                if (valid) {
                    this.formDate.deliveryPlanId = this.stockRemVal.id
                    let data = {
                        url: 'MID-OPERATE-LEASE/messageService/orderService/selfPickConfirm',
                        body: this.formDate
                    }
                    this.invoke(data).then(res => {
                        if (!res) {
                            setTimeout(() => {
                                this.$Message.success('出库确认成功');

                                this.cancels()
                                this.$emit('search')
                            }, 1400)
                        }
                    }).catch(err => {
                        this.loading = false
                        setTimeout(() => {
                            this.loading = true
                        }, 10)

                    })
                } else {
                    this.loading = false
                    setTimeout(() => {
                        this.loading = true
                    }, 10)
                }
            })

        },
        cancels() {
            this.$refs['formValidate'].resetFields()
            this.formDate.attachmentFileIds = []
            this.stockRemVal.show = false
            this.$refs.upFiles.$refs.uploadFile.clearFiles()
            this.formDate.selfPickAckComment =""
        }

    }

}
</script>

<style lang="scss" scoped>
</style>